// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module__footer___1aVD9"};